import axios from '../axios'

// モジュール並び替え（module_ids: 新しい順のID配列）
const reorderModulesApi = async (courseId, moduleIds) => {
  return await axios.put(`api/lms/courses/${courseId}/modules/reorder`, { module_ids: moduleIds })
}

export default reorderModulesApi
